import SalesforceLead from './SalesforceLead';

export default SalesforceLead;
